import type { RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { PER_PAGE_SIZE } from "consts/transactions";
import type { FetchResourceSettings } from "hooks/useFetchResource";
import { useFetchFeatureResource, useSessionEffect } from "hooks";
import { changeRolesLoadingState, changeRolesSlice } from "./slice";
import { getRoles as getRolesRequest } from "./api";

const userRolesSessionEffectSymbol = Symbol('userRolesSessionEffect');

export const useUserRoles = ({
    shouldFetchAll = true,
    perPage = PER_PAGE_SIZE
}: FetchResourceSettings = {}) => {
    const getRoles = useFetchFeatureResource({
        shouldFetchAll,
        perPage,
        resourceRequest: getRolesRequest,
        changeLoadingState: changeRolesLoadingState,
        changeSlice: changeRolesSlice,
        condition: getState => {
            const { users } = getState() as RootState;

            return ![
                ApiState.Pending,
                ApiState.Succeeded
            ].includes(users.rolesLoadingState);
        }
    });

    useSessionEffect(() => {
        getRoles();
    }, userRolesSessionEffectSymbol);
};

export default useUserRoles;
